<template>
  <card class="card">
    <div class="card-body">
      <h2 class="pt-0 mt-0">
        <i class="fas fa-wrench text-primary"></i>{{$t('asf.titleadd')}}
      </h2>
      <hr>
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <fg-input type="text" :label="$t('asf.name')" :placeholder="$t('asf.name')" v-model="asf.name"></fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="text" :label="$t('asf.cnpj')" :placeholder="$t('asf.cnpj')" v-model="asf.vat"></fg-input>
            </div>

            <h5 class="text-muted col-md-12">Certificado</h5>

            <div class="col-md-2">
              <b-form-checkbox
                id="asf-certified"
                v-model="asf.certified"
                name="asf-certified"
                value="1"
                v-on:click="linkPart"
                unchecked-value="0"
              >
               <label for="asf-certified">ASF Certificada</label>
              </b-form-checkbox>
            </div>

            <div class="col-md-5">              
               <b-form-datepicker
                  id="datepicker-initial_date"
                  v-model="asf.initial_date"
                  class="m-0 p-0"
                  size="sm"
                  :max="max_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :dark=true
                  :placeholder="$t('dashboard.select_date')"
                ></b-form-datepicker>
            </div>

            <div class="col-md-5">
              <b-form-datepicker
                  id="datepicker-expiry_date"
                  v-model="asf.expiry_date"
                  class="m-0 p-0"
                  size="sm"
                  :max="max_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :dark=true
                  :placeholder="$t('dashboard.select_date')"
                ></b-form-datepicker>
            </div>

          </div>

          <fg-address v-model="asf.addresses" multiple="true"></fg-address>
          <br>
          <fg-phone v-model="asf.phones" multiple="true"></fg-phone>
          <div class="text-left">
            <p-button type="primary" @click.native.prevent="saveAsf">{{$t('asf.button.save')}}</p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </div>
  </card>
</template>
<script>
export default {
  data() {
    return {
      asf: {
        name: "",
        vat: "",
        addresses: [{}],
        phones: [{}]
      }
    };
  },
  methods: {
    saveAsf() {
      this.$store
        .dispatch("asfs/addAsf", this.asf)
        .then(response => {
          this.$router.push("asfs");
          this.$notify({
            type: "success",
            message: this.$t('asf.message.successadd')
          });
        })
        .catch(error => {
          this.$notify({
            type: "danger",
            message: "Error! Try again."
          });
        });
    }
  }
};
</script>
<style>
</style>
